module.exports = __webpack_public_path__ + "static/media/ISFP.876730a3.png";